import { Injectable } from '@angular/core';
import { DatasetsService } from './datasets.service';
import { DatasetDetails } from '@models/dataset';
import { ResultsStoreService } from '../results/results-store.service';
import { ImporterState } from '@interfaces/importer-state';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImporterService {
  public importerStatus$ = new BehaviorSubject<ImporterState>(ImporterState.idle);
  public dialogLoadedFrom: 'sim-button' | 'import-button';

  constructor(private datasetsService: DatasetsService, private store: ResultsStoreService) {
    this.setActiveDataset(this.datasetsService.currentDataset);
  }

  public loadNewDataset() {
    console.log('loaded');
    // PH for testing. This call only has to be issued on Update
    this.store.checkIfResultsOutOfDate();
  }

  public updateDataset(datasetId: number) {
    console.log(`Updated dataset #${datasetId}`);
    this.store.checkIfResultsOutOfDate();
  }

  public setActiveDataset(dataset: DatasetDetails) {
    this.datasetsService.currentDataset = dataset;
  }

  // ! TODO Placeholder. Remove when the import process is refactored out of the import-alm-dataset.component into this service
  public reloadStoreAndCheckIfResultsOutOfDate() {
    this.store.loadDataFromDB(false, false, true);
    this.store.checkIfResultsOutOfDate();
  }
}
